@if (apiloaded) {
  <div class="row col-12 col-sm-12" [ngClass]="isMobile? 'px-0':'pr-0'">
    @if (!isMobile) {
      <div class="col-3 col-sm-3">
        <app-my-account-left-sidenav [navState]="'SupportTicketNavNode'"></app-my-account-left-sidenav>
      </div>
    }
    <div [ngClass]="isMobile? 'col-12 px-0' :'col-9 col-sm-9 pr-0'">
      <h1 class="myProfileTopHeader m-0">{{'common.text_account_orderHistory_orderStatus'|cxTranslate}}
      </h1>
      <div class="myProfileBody">
        <form [formGroup]="ticketForm" (ngSubmit)="onSubmit()" novalidate autocomplete="off">
          <div class="customerIdContainer">
            <div class="container-cus-block">
              <div class="acc-sec-content">
                <div class="customer-block-title camelCase">
                {{'common.basket_export_user_customerID'|cxTranslate}}</div>
                <div class="select">
                  <select name="customer" id="customerId" formControlName="defaultSoldTo">
                    @for (opt of myTicket?.b2bUnitsWSList; track opt) {
                      <option [value]="opt?.uid"
                        [disabled]="opt?.orderBlocked"
                        [selected]="$any(myTicket)?.defaultSoldTo == opt?.uid"
                        [ngClass]="opt?.orderBlocked ? 'bgGrey':''">
                        @if (opt?.salesArea1) {
                          <span> {{ opt?.salesArea1}}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.salesArea2) {
                          <span>{{opt?.salesArea2
                          |cxTranslate}}&nbsp;|&nbsp;</span>
                        }
                        @if (opt?.salesArea3) {
                          <span> {{opt?.salesArea3 }}</span>
                        }
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-6">
              <label for="input"
                class="customPoNumber">{{'common.text_account_table_header_poNumber'|cxTranslate}}
              </label>
              <input type="text" class="customerPO">
            </div>
            <div class="col-xs-12 col-sm-12 col-md-6 pl-0 pr-5">
              <label for="input"
                class="orderStatus">{{'common.text_account_orderHistory_orderStatus'|cxTranslate}}
              </label>
              <input type="text" class="orderStatusText">
            </div>
          </div>
          <div class="dateStausSection row col-12 col-sm-12">
            <div class="form-group col-xs-12 p-0 col-sm-12 col-md-12 col-lg-6">
              <label for="titleCode"
              class="control-label">{{'common.text_account_table_header_order'|cxTranslate}}</label>
              <div class="select-box">
                <input name="titleCode" class="form-control selecter" formControlName="status">
              </div>
            </div>
            <div class="col-xs-12 col-12 col-sm-6 col-md-5  col-lg-3 form-group mb-3 align-self-end"
              [class.px-0]="isMobile">
              <div class="form-group">
                <label for="startDate">
                  {{'common.text_supporttickets_search_from_date'|cxTranslate}}*
                </label>
                <input class="form-control bsdpicker kb-datePickerIcon" placeholder="Datepicker"
                  bsDatepicker formControlName="startDateString" [maxDate]="today"
                  [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY', showWeekNumbers:false, displayOneMonthRange: true }"
                  [daysDisabled]="[6,0]">
                </div>
              </div>
              <div class="col-xs-12 col-12 col-sm-6 col-md-5 col-lg-3  form-group mb-3 pr-1 align-self-end">
                <div class="form-group">
                  <label for="enddate">
                    {{'common.text_supporttickets_search_to_date'|cxTranslate}}*
                  </label>
                  <input class="form-control bsdpicker kb-datePickerIcon" placeholder="Datepicker"
                    bsDatepicker formControlName="endDateString" [maxDate]="today"
                    [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY',showWeekNumbers:false, displayOneMonthRange: true }"
                    [daysDisabled]="[6,0]">
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-6">
                  <label for="input"
                    class="bendixPartNumber">{{'common.text_account_naPartNumber'|cxTranslate}}
                  </label>
                  <input type="text" class="bendixPartText">
                </div>
                <div class="col-xs-12 col-sm-12 col-md-6 d-flex checkBoxDiv">
                  <label for="input"
                    class="orderStatus">{{'common.text_Show_orders_of_coworkers'|cxTranslate}}
                  </label>
                  <input type="checkbox" class="showCheckBox">
                </div>
              </div>
              <div class="myProfileButtonContainer mt-5 row margin-right-30">
                <div [ngClass]="isMobile ? ' d-flex flex-column w-100 padding-x': 'ml-auto'">
                  <button class=" btn btn-primary btn-blue fs-20 px-4" type="button" (click)="reset()"
                  [ngClass]="isMobile ? 'mb-3':''">{{'common.text_software_search_button_reset_lable'|cxTranslate}}</button>
                  <button class=" btn btn-primary fs-20" [ngClass]="isMobile ? '': 'ml-3'"
                    type="submit">{{'common.text_training_request_table_search'|cxTranslate}}<img
                  src="/icons/link-white.svg" style="width: 20px;"></button>
                </div>
              </div>
            </form>
            @if ( userList?.ticketsList && userList?.ticketsList.length==0) {
              <div class="py-5 noTickets">
                <b>{{'common.text_account_supporttickets_noSupporttickets'|cxTranslate}}</b>
              </div>
            }
          </div>
          @if ( userList?.ticketsList && userList?.ticketsList.length==0) {
            <div class="gray-search-result-box">
              {{grayTotalticketsValue}}
            </div>
          }
          <!-- here the content goes for table to display the tickets -->
          @if ( userList?.ticketsList && userList?.ticketsList.length>0) {
            <div [class.sort-section]="isMobile">
              <div class="gray-search-result-box">
                {{grayTotalticketsValue}}
              </div>
              <div class="account-overview-table mycompany-manageUser">
                <table class="responsive-table table table-bordered table-blue">
                  <thead>
                    <tr class="responsive-table-head hidden-xs hidden-sm">
                      <th scope="col">{{'common.text_account_supporttickets_ticketType'|cxTranslate}}</th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('ticketId')">
                          <span>{{'common.text_account_supporttickets_ticketId'|cxTranslate}}
                            @if (sortByTicketId == 'asc') {
                              &#8593;
                            }
                            @if (sortByTicketId == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('category')">
                          <span>{{'common.text_account_supporttickets_category'|cxTranslate}}
                            @if (sortByCategory == 'asc') {
                              &#8593;
                            }
                            @if (sortByCategory == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('headline')">
                          <span>{{'common.text_account_supporttickets_subject'|cxTranslate}}
                            @if (sortBySubject == 'asc') {
                              &#8593;
                            }
                            @if (sortBySubject == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('byDateCreated')">
                          <span>{{'common.text_account_supporttickets_dateCreated'|cxTranslate}}
                            @if (sortByDateCreated == 'asc') {
                              &#8593;
                            }
                            @if (sortByDateCreated == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('modifiedtime')">
                          <span>{{'common.text_account_supporttickets_dateUpdated'|cxTranslate}}
                            @if (sortByDateUpdated == 'asc') {
                              &#8593;
                            }
                            @if (sortByDateUpdated == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                      <th scope="col">
                        <a class="a-underline" (click)="sort('state')">
                          <span>{{'common.text_account_supporttickets_status'|cxTranslate}}
                            @if (sortByStatus == 'asc') {
                              &#8593;
                            }
                            @if (sortByStatus == 'desc') {
                              &#8595;
                            }
                          </span>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  @if (userList) {
                    <tbody>
                      @for (item of userList?.ticketsList; track item) {
                        <tr class="responsive-table-item">
                          <td class="responsive-table-cell">
                            <a>
                              <span class="mycompnay-registration-value pointer">
                                @if (item.ticketType.code == 'WEB') {
                                  {{'common.text_account_supporttickets_createTicket_tickettype_WEB'|cxTranslate}}
                                } @else {
                                  {{'common.text_account_supporttickets_createTicket_tickettype_MANUAL'|cxTranslate}}
                                }
                              </span></a>
                            </td>
                            <td class="responsive-table-cell">
                              <a><span
                              class="mycompnay-registration-value pointer">{{item.ticketID}}</span></a>
                            </td>
                            <td class="responsive-table-cell">
                              <a>
                                <span class="mycompnay-registration-value pointer">
                                  @if (item.kbecomTicketCategory.code == 'PSA') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_PSA'|cxTranslate}}
                                  }
                                  @if (item.kbecomTicketCategory.code == 'PSG') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_PSG'|cxTranslate}}
                                  }
                                  @if (item.kbecomTicketCategory.code == 'TST') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_TST'|cxTranslate}}
                                  }
                                  @if (item.kbecomTicketCategory.code == 'Order') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_ORDER'|cxTranslate}}
                                  }
                                  @if (item.kbecomTicketCategory.code == 'Warranty') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_WARRANTY'|cxTranslate}}
                                  }
                                  @if (item.kbecomTicketCategory.code == 'Core') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_CORE'|cxTranslate}}
                                  }
                                  @if (item.kbecomTicketCategory.code == 'OTH') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_OTH'|cxTranslate}}
                                  }
                                  @if (item.kbecomTicketCategory.code == 'other') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_SOTHER'|cxTranslate}}
                                  }
                                </span></a>
                              </td>
                              <td class="responsive-table-cell">
                                <a><span
                                class="mycompnay-registration-value pointer">{{item.subject}}</span></a>
                              </td>
                              <td class="responsive-table-cell">
                                <span class="mycompnay-registration-value">
                                  <span>{{item?.creationDate | date:'dd/MM/yyyy'}}</span>
                                </span>
                              </td>
                              <td class="responsive-table-cell">
                                <span class="mycompnay-registration-value">
                                  <span>{{item?.lastModificationDate2 | date:'dd/MM/yyyy hh:mm'}}</span>
                                </span>
                              </td>
                              <td class="responsive-table-cell">
                                <span class="mycompnay-registration-value">
                                  @if (item.status?.code == 'ENQUIRY') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_ENQUIRY'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'COMPLAINT') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_COMPLAINT'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'PROBLEM') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_PROBLEM'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'NEW') {
                                    {{'common.text_account_supporttickets_createTicket_status_NEW'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'OPEN') {
                                    {{'common.text_account_supporttickets_createTicket_status_OPEN'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'Core') {
                                    {{'common.text_account_supporttickets_createTicket_ticketCategory_CORE'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'INPROGRESS') {
                                    {{'common.text_account_supporttickets_createTicket_status_INPROGRESS'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'CUSTOMERACTION') {
                                    {{'common.text_account_supporttickets_createTicket_status_CUSTOMERACTION'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'COMPLETED') {
                                    {{'common.text_account_supporttickets_createTicket_status_COMPLETED'|cxTranslate}}
                                  }
                                  @if (item.status?.code == 'CLOSED') {
                                    {{'common.text_account_supporttickets_createTicket_status_CLOSED'|cxTranslate}}
                                  }
                                </span>
                              </td>
                            </tr>
                          }
                        </tbody>
                      }
                    </table>
                  </div>
                  <div class="account-orderhistory-pagination company-users-pagination">
                    <div class="product__list--wrapper py-2">
                      <div class="pagination-bar">
                        <div class="pagination-toolbar">
                          <div class="row sort-refine-bar">
                            <div class="col-xs-12 col-sm-6 col-md-6 bottom-result">
                              <div class="pagination-result">
                                <label>{{paginationBarValue}}</label>
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-6 kb-pagination-right kb-pagination"
                              [ngClass]="isMobile? 'mb-3': ''">
                              <kb-pagination [pagination]="$any(userList)?.pagination" [defaultPage]="0"
                              (viewPageEvent)="changePageCustom($event, $any(userList)?.searchPageData)"></kb-pagination>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }